<!--
  <!>WARNING<!>
  This is really dumb but IE 11 cares about the order of attributes.
  Make sure that `{value}` comes immediatley after `type="checkbox"`.
  Otherwise `{value}` will be `on` and not the message text. But only
  on the first render making it very tricky to track down.
-->
<input
  {id}
  class="ne-checkbox"
  type="checkbox"
  {value}
  {checked}
  data-heap-checkbox="{heapId}"
  data-test-id="{testId}"
  on:click="{event => choose(event)}" />
<label for={id} class="ne-message-box">
  <span class="ne-message">
    <slot></slot>
  </span>
</label>

<style>
  .ne-checkbox {
    border-radius: 2em;
  }

  .ne-checkbox + .ne-message-box::before {
    border-color: #666e7e;
    background-color: #fff;
  }

  .ne-checkbox:checked + .ne-message-box::before {
    border-color: #CE2333;
    background-color: #CE2333;
  }

  .ne-checkbox + .ne-message-box::after {
    content: none;
  }

  .ne-checkbox:checked + .ne-message-box::after {
    content: '';
  }

  .ne-checkbox {
    opacity: 0;
  }

  .ne-message-box {
    padding: 1em;
    cursor: pointer;
    display: block;
    position: relative;
    padding-left: 2em;
  }

  .ne-message-box::before,
  .ne-message-box::after {
    position: absolute;
    content: '';
    display: inline-block;
  }

  .ne-message-box::before {
    border-width: .0625em;
    border-style: solid;
    height: 1em;
    width: 1em;
    border-radius: .125em;
    line-height: 1.5em;
    left: 0;
  }

  .ne-message-box::after {
    height: .3em;
    width: .5em;
    border-left: .1em solid #fff;
    border-bottom: .1em solid #fff;

    transform: rotate(-50deg);

    left: 0.25em;
    top: 1.3em;
  }

  .ne-message {
    justify-self: center;
    align-self: center;
    width: 100%;
  }
</style>

 <script>
   export let id;
   export let value;
   export let checked;
   export let choose;
   export let heapId;
   export let testId;
 </script>
